import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.change.impact',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'records',
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'workstream',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '``': {
                                  '@$': 'workstream',
                                },
                              },
                              {
                                '??': [
                                  {
                                    '@.': '!workstream',
                                  },
                                  {
                                    '[]': [],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'degreeOfChange',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!degree_of_change',
                              },
                              {
                                '``': {
                                  '@$': 'degreeOfChange',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'valueOfChange',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!value_of_change',
                              },
                              {
                                '``': {
                                  '@$': 'valueOfChange',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'department',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '``': {
                                  '@$': 'department',
                                },
                              },
                              {
                                '@.': '!impacted_groups',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'type',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '``': {
                                  '@$': 'type',
                                },
                              },
                              {
                                '@.': '!type',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'anticipatedResponseOfChange',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!anticipated_response_of_change',
                              },
                              {
                                '``': {
                                  '@$': 'anticipatedResponseOfChange',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'validationStatus',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!validation_status',
                              },
                              {
                                '``': {
                                  '@$': 'validationStatus',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'workstream',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '``': {
                              '@$': 'workstream',
                            },
                          },
                          {
                            '??': [
                              {
                                '@.': '!workstream',
                              },
                              {
                                '[]': [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'degreeOfChange',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!degree_of_change',
                          },
                          {
                            '``': {
                              '@$': 'degreeOfChange',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'valueOfChange',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!value_of_change',
                          },
                          {
                            '``': {
                              '@$': 'valueOfChange',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'department',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '``': {
                              '@$': 'department',
                            },
                          },
                          {
                            '@.': '!impacted_groups',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'type',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '``': {
                              '@$': 'type',
                            },
                          },
                          {
                            '@.': '!type',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'anticipatedResponseOfChange',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!anticipated_response_of_change',
                          },
                          {
                            '``': {
                              '@$': 'anticipatedResponseOfChange',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'validationStatus',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!validation_status',
                          },
                          {
                            '``': {
                              '@$': 'validationStatus',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!change_impacts:!change_impact',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      type: {
                        '{}': {
                          value: {
                            '@.': '!type',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      phase: {
                        '{}': {
                          value: {
                            '@.': '!phase',
                          },
                        },
                      },
                      topic: {
                        '{}': {
                          value: {
                            '@.': '!topic',
                          },
                        },
                      },
                      sprint: {
                        '{}': {
                          value: {
                            '@.': '!sprint',
                          },
                        },
                      },
                      status: {
                        '{}': {
                          value: {
                            '@.': '!status',
                          },
                        },
                      },
                      system: {
                        '{}': {
                          value: {
                            '@.': '!system',
                          },
                        },
                      },
                      priority: {
                        '{}': {
                          value: {
                            '@.': '!priority',
                          },
                        },
                      },
                      userStory: {
                        '{}': {
                          value: {
                            '@.': '!user_story',
                          },
                        },
                      },
                      keyBenefit: {
                        '{}': {
                          value: {
                            '@.': '!key_benefit',
                          },
                        },
                      },
                      workstream: {
                        '{}': {
                          value: {
                            '@.': '!workstream',
                          },
                        },
                      },
                      futureState: {
                        '{}': {
                          value: {
                            '@.': '!future_state',
                          },
                        },
                      },
                      currentState: {
                        '{}': {
                          value: {
                            '@.': '!current_state',
                          },
                        },
                      },
                      areaOfConcern: {
                        '{}': {
                          value: {
                            '@.': '!area_of_concern',
                          },
                        },
                      },
                      otherComments: {
                        '{}': {
                          value: {
                            '@.': '!other_comments',
                          },
                        },
                      },
                      valueOfChange: {
                        '{}': {
                          value: {
                            '@.': '!value_of_change',
                          },
                        },
                      },
                      degreeOfChange: {
                        '{}': {
                          value: {
                            '@.': '!degree_of_change',
                          },
                        },
                      },
                      impactedGroups: {
                        '{}': {
                          value: {
                            '@.': '!impacted_groups',
                          },
                        },
                      },
                      targetGoLiveDate: {
                        '{}': {
                          value: {
                            '@.': '!target_go_live_date',
                          },
                        },
                      },
                      validationStatus: {
                        '{}': {
                          value: {
                            '@.': '!validation_status',
                          },
                        },
                      },
                      engagementsNeeded: {
                        '{}': {
                          value: {
                            '@.': '!engagements_needed',
                          },
                        },
                      },
                      communicationsNotes: {
                        '{}': {
                          value: {
                            '@.': '!communications_notes',
                          },
                        },
                      },
                      communicationsNeeded: {
                        '{}': {
                          value: {
                            '@.': '!communications_needed',
                          },
                        },
                      },
                      trainingImplications: {
                        '{}': {
                          value: {
                            '@.': '!training_implications',
                          },
                        },
                      },
                      trainingImplicationsNotes: {
                        '{}': {
                          value: {
                            '@.': '!training_implications_notes',
                          },
                        },
                      },
                      anticipatedResponseOfChange: {
                        '{}': {
                          value: {
                            '@.': '!anticipated_response_of_change',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Impact ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'targetGoLiveDate',
                  direct: {
                    '{}': {
                      name: 'Date',
                      type: 'DATE',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Change Impact Title',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'descr',
                  direct: {
                    '{}': {
                      name: "What's Changing Summary",
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'currentState',
                  direct: {
                    '{}': {
                      name: 'Current State',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'futureState',
                  direct: {
                    '{}': {
                      name: 'Future State',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'workstream',
                  direct: {
                    '{}': {
                      name: 'Workstream',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_workstream',
                          isMultiselect: true,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'phase',
                  direct: {
                    '{}': {
                      name: 'Phase/Epic',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_phase',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'sprint',
                  direct: {
                    '{}': {
                      name: 'Sprint',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_sprint',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'topic',
                  direct: {
                    '{}': {
                      name: 'Topic',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'impactedGroups',
                  direct: {
                    '{}': {
                      name: 'Department',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_department',
                          isMultiselect: true,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'degreeOfChange',
                  direct: {
                    '{}': {
                      name: 'Degree of Change',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'areaOfConcern',
                  direct: {
                    '{}': {
                      name: 'Area of Concern',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'keyBenefit',
                  direct: {
                    '{}': {
                      name: 'Key Benefit',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'type',
                  direct: {
                    '{}': {
                      name: 'Type',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_type',
                          isMultiselect: true,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'anticipatedResponseOfChange',
                  direct: {
                    '{}': {
                      name: 'Anticipated Response of Change',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_anticipated_response',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'validationStatus',
                  direct: {
                    '{}': {
                      name: 'Validation Status',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_validation_status',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'communicationsNeeded',
                  direct: {
                    '{}': {
                      name: 'Communications Needed',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_yes_no_na',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'communicationsNotes',
                  direct: {
                    '{}': {
                      name: 'Communications Notes',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'trainingImplications',
                  direct: {
                    '{}': {
                      name: 'Training Implications',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_yes_no_na',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'trainingImplicationsNotes',
                  direct: {
                    '{}': {
                      name: 'Training Implications Notes',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'userStory',
                  direct: {
                    '{}': {
                      name: 'User Story',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'otherComments',
                  direct: {
                    '{}': {
                      name: 'Other Comments',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
